import { getRouteApi } from '@tanstack/react-router';
import type { ProjectTabId } from '../constants/question.constants';
import type { ProjectManagementSearch } from '../types/question.types';

const route = getRouteApi('/_auth/question/projects');

type ProjectManagementView = Pick<ProjectManagementSearch, 'tab' | 'projectId' | 'userId'>;

export function useProjectManagementView() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const updateView = (view: ProjectManagementView) =>
    navigate({
      search: (previous) => ({ ...previous, ...view }),
      replace: true,
    });

  return {
    activeTabId: search.tab ?? 'projects',
    openProjectId: search.projectId,
    assignmentUserId: search.userId,
    changeTab: (tab: ProjectTabId) => updateView({ tab }),
    openProject: (projectId: number) =>
      updateView({ tab: 'assignments', projectId, userId: undefined }),
    closeProject: () => updateView({ tab: undefined, projectId: undefined, userId: undefined }),
    changeAssignmentUser: (userId: number | undefined) => updateView({ userId }),
  };
}
